import React, { useEffect } from 'react';

import { Checkbox, ErrorArea, Form, Input, PasswordInput, Submit } from '@kodkafa/reform';

import {
  AuthDto,
  LoginDto,
  useAuthControllerLoginMutation,
} from '@/store/services/MidleNestApi.service';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { connect } from 'react-redux';
import { selectAuth } from '@/store/features/auth.slice';
import { errorHandler } from '@/utils/error.handler';
import { ReformSetError } from '@kodkafa/reform/dist/Form';
import { RootState } from '@/store';
import { useTranslation } from 'react-i18next';
import Connections from '@/components/shared/connections/Connections';
import { useError, useModal } from '@/hooks';
import { Divider } from '@/components';

// import { useModal } from '@/hooks/useModal';

interface Props {
  authData: AuthDto;
}

function LoginComponent({ authData }: Props) {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const { showModalByLink } = useModal();
  const location = useLocation();
  // if Its is true, it is in the page view.
  const openInModalTrick = !location.pathname.match(/login/);

  const [mutation] = useAuthControllerLoginMutation();
  const { hideModal } = useModal();
  const handleSubmit = async (data: LoginDto, setError: ReformSetError) => {
    await mutation(data)
      .unwrap()
      .then(() => {
        gtag('event', 'login', { username: data.username });
        return navigate('/', {});
      })
      .catch((error) => errorHandler(error, setError));
  };

  const error = useError();

  useEffect(() => {
    if (authData.refreshToken) navigate('/');
  }, [authData.name]);

  return (
    <div className='flex flex-col mx-auto max-w-screen sm:w-96 text-sm'>
      <h2 className='mt-4 flex items-center justify-center space-x-8 font-bold md:text-xl'>
        <span className='text-gray-900 dark:text-[#FFDA68] cursor-pointer'>{t('Log In')}</span>
        <a
          onClick={showModalByLink}
          href='/register'
          data-modal={openInModalTrick}
          className='text-gray-500 dark:text-white cursor-pointer'
        >
          {t('Sign Up')}
        </a>
      </h2>
      <div className='text-sm mt-4 mb-6 text-center dark:text-white'>
        {t('Have a business account?')}{' '}
        <a className='text-blue-500 dark:text-blue-400 underline' href='https://business.midle.io/'>
          {t('Login')}
        </a>
      </div>
      <Divider className='mb-4 !text-sm text-gray-600 dark:text-white'>{t('CONNECT WITH')}</Divider>
      <Connections />
      {/*      <button
        onClick={() =>
          error.push({
            status: [300, 400, 500][Math.floor(Math.random() * 3)],
            name: 'HATA',
            message: 'Error messajiii',
            ttl: 10000,
          })
        }
      >
        PUSH ERROR or ALERT
      </button>*/}
      <Divider className='mt-4 mb-2 dark:text-[#FFDA68]'>OR</Divider>
      <Form onSubmit={handleSubmit} className='flex !gap-4'>
        <div>
          <Input
            label='Username'
            name='username'
            placeholder='Username or email'
            className='dark:!bg-transparent dark:!border-[#FFDA68] dark:!text-white dark:placeholder:text-white/50 dark:ring-transparent'
          />
        </div>
        <div className=''>
          <Input
            className='dark:!bg-transparent dark:!border-[#FFDA68] dark:!text-white dark:placeholder:text-white/50 dark:ring-transparent'
            name='password'
            label='Password'
            type='password'
            placeholder='Password'
          />
        </div>
        <div className='flex justify-between'>
          {/* Create a checkbox with pure html tags */}
          <div className='flex items-center'>
            <input
              className='rounded border-gray-300 bg-transparent dark:border-[#FFDA68] checked:!border-transparent dark:checked:bg-[#FFDA68]/50'
              // if checked, remove border color
              type='checkbox'
              name='remember'
            />
            <label
              htmlFor='remember'
              className='dark:text-[#FFDA68] cursor-pointer pl-2'
              onClick={(e) => {
                // Check the checkbox
                (e.currentTarget.previousSibling as HTMLInputElement | undefined)?.click();
              }}
            >
              {t('Remember Me')}
            </label>
          </div>
          <Link to='/recovery' className='dark:text-white' onClick={hideModal}>
            Forgotten password?
          </Link>
        </div>
        <ErrorArea />
        <div>
          <button
            type='submit'
            className='w-full text-sm font-semibold rounded-lg py-3 bg-blue-500 dark:bg-[#FFDA68] text-white dark:text-[#151515]'
          >
            {t('Log In')}
          </button>
        </div>
      </Form>
      {/*<hr className='my-4 border-t' />*/}
      {/*<p className='text-center'>*/}
      {/*  Don&apos;t have an account yet?{' '}*/}
      {/*  <Link to='/register' className='font-bold'>*/}
      {/*    Create one*/}
      {/*  </Link>*/}
      {/*</p>*/}
      {/*<button className='block m-3' onClick={closeModal}>*/}
      {/*  CLOSE MODAL*/}
      {/*</button>*/}
      {/*<button className='block m-3' onClick={openModal}>*/}
      {/*  OPEN ANOTHER MODAL*/}
      {/*</button>*/}
    </div>
  );
}

export default connect(
  (state: RootState): Props => ({
    authData: selectAuth(state),
  }),
)(LoginComponent);
